import { useCallback, useEffect, useState } from 'react';

import { Flex, Space } from '@/components/base';
import ContentPreview from '@/components/Preview/ContentPreview';
import Typo from '@/components/Typography/Typo';
import useAgentStore from '@/features/Agent/stores';
import useColor from '@/hooks/domain/useColor';
import service from '@/services/index';
import useLocaleStore from '@/stores/LocaleStore';

import S from './styled';
import type { Props } from './types';

const FeedbackCustomerPreview = ({ alias, name, pos }: Props) => {
  const [data, setData] = useState<CustomerT | null>(null);
  const agentMap = useAgentStore((state) => state.agentMap);
  const regionMap = useLocaleStore((state) => state.regionMap);

  const color = useColor();

  const fetchData = useCallback(async () => {
    const res = await service.contact.fetchCustomer(alias);
    setData(res);
  }, [alias]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <>
      {data ? (
        <ContentPreview style={pos}>
          <S.Style>
            <Typo type="body2" weight="sb">
              {name}
            </Typo>
            <Flex g="8px" w="wrap">
              <Space h="16px" />
              {data.job_function && (
                <S.ItemWrapper g="6px">
                  <Typo type="body3" color={color.gray600}>
                    job function
                  </Typo>
                  <Typo type="body3" color={color.gray800}>
                    {data.job_function}
                  </Typo>
                </S.ItemWrapper>
              )}
              {data.email && (
                <S.ItemWrapper g="6px">
                  <Typo type="body3" color={color.gray600}>
                    email
                  </Typo>
                  <Typo type="body3" color={color.gray800}>
                    {data.email}
                  </Typo>
                </S.ItemWrapper>
              )}
              {data.agent && (
                <S.ItemWrapper g="6px">
                  <Typo type="body3" color={color.gray600}>
                    agent
                  </Typo>
                  <Typo type="body3" color={color.gray800}>
                    {agentMap[data.agent].name}
                  </Typo>
                </S.ItemWrapper>
              )}
              {data.country && (
                <S.ItemWrapper g="6px">
                  <Typo type="body3" color={color.gray600}>
                    country
                  </Typo>
                  <Typo type="body3" color={color.gray800}>
                    {regionMap[data.country].country}
                  </Typo>
                </S.ItemWrapper>
              )}
              {data.feedback_count && (
                <S.ItemWrapper g="6px">
                  <Typo type="body3" color={color.gray600}>
                    feedback count
                  </Typo>
                  <Typo type="body3" color={color.gray800}>
                    {data.feedback_count}
                  </Typo>
                </S.ItemWrapper>
              )}
              {data.type && (
                <S.ItemWrapper g="6px">
                  <Typo type="body3" color={color.gray600}>
                    type
                  </Typo>
                  <Typo type="body3" color={color.gray800}>
                    {data.type}
                  </Typo>
                </S.ItemWrapper>
              )}
            </Flex>
          </S.Style>
        </ContentPreview>
      ) : (
        <></>
      )}
    </>
  );
};

export default FeedbackCustomerPreview;
